export default "__VITE_ASSET__DVt50oFF__"